
export default function Passenger({ formData, setFormData, validationErrors, showNotification, setShowNotification }) {

    const handleChange = (e) => {
        const { name, value } = e.target;

        let intValue = parseInt(value, 10);
        if (name === "passengerCount") {
            if (intValue < 1 || intValue > 4) {
                setShowNotification(true);
            } else {
                setShowNotification(false);
            }
        }
        if (name === "kidsCount") {
            if (intValue < 0 || intValue > 5) {
                setShowNotification(true);
            } else {
                setShowNotification(false);
            }
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    return (
        <div className="booking-step-passenger">
            <span className="heading">
                Enter Passenger details
            </span>
            <div className="inner-box">
                <div className="left">
                    <div className="form-controller">
                        <label>Passenger Name</label>
                        <input type="text" className={validationErrors.passengerName ? "input-error" : ""} name="passengerName" onChange={handleChange} id="passengerName" value={formData.passengerName} placeholder="Enter Your Name" />
                    </div>
                    <div className="form-controller">
                        <label>Passenger Phone</label>
                        <input type="text" className={validationErrors.passengerPhone ? "input-error" : ""} name="passengerPhone" onChange={handleChange} id="passengerPhone" value={formData.passengerPhone} placeholder="Enter Your Email Address " />
                    </div>
                    <div className="form-controller">
                        <label>Passenger Email</label>
                        <input type="text" className={validationErrors.passengerEmail ? "input-error" : ""} name="passengerEmail" onChange={handleChange} id="passengerEmail" value={formData.passengerEmail} placeholder="Enter Your Mobile number" />
                    </div>
                </div>
                <div className="right">
                    <div className="form-controller">
                        <label>Passenger Count</label>
                        <input type="number" className={validationErrors.passengerCount ? "input-error" : ""} min={1} max={4} name="passengerCount" onChange={handleChange} id="passengerCount" value={formData.passengerCount} placeholder="Number of Adult Passengers" />
                    </div>
                    <div className="form-controller">
                        <div><i className={`fa-solid fa-exclamation ${showNotification ? "redc" : ""}`}></i></div>
                        {showNotification ? (
                            <div>
                                FOR PASSENGER COUNT IS MORE THAN 4, ONLINE BOOKING WON'T BE POSSIBLE. EITHER BOOK AS SEPARATE GROUP WITH MAXIMUM 4 PASSENGERS OR TRY HIGHER VEHICLES THROUGH SELF BOOKING KIOSK OR PREPAID TAXI COUNTER AT THE AIRPORT.
                            </div>
                        ) : (
                            <div>
                                NUMBER OF PASSENGER REQUIRED SEAT [ IT IS DESIRABLE TO OPT SEAT FOR PASSENGER ABOVE 6 YEARS OLD.
                                IF PASSENGER LESS THAN 6 YEARS OLD REQUIRE SEAT, PLEASE ADD THEM TO THE COUNT]
                                MAXIMUM POSSIBLE PASSENGER COUNT PER BOOKING WILL BE 4 ONLY. IF THE PASSENGER COUNT IS MORE THAN 4,
                                EITHER BOOK AS SEPARATE OR TRY HIGHER VEHICLES THROUGH SELF BOOKING KIOSK OR PREPAID TAXI COUNTER AT THE AIRPORT.
                            </div>
                        )}
                    </div>
                    <div className="form-controller">
                        <label>Kids Count</label>
                        <input type="number" className={validationErrors.kidsCount ? "input-error" : ""} name="kidsCount" min={0} max={5} onChange={handleChange} id="kidsCount" value={formData.kidsCount} placeholder="Number of Child Passengers" />
                    </div>
                    <div className="form-controller">
                        <div><i className='fa-solid fa-exclamation'></i></div>
                        <div>
                            NUMBER OF PASSENGER NOT REQUIRED SEAT [ IT IS DESIRABLE LESS THAN 6 YEARS OLD ONLY, EVEN THOUGH SEAT CAN BE SELECTED FOR THIS RANGE OF PASSENGERS AS WELL]
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
